import { render, staticRenderFns } from "./MyBrand.vue?vue&type=template&id=3f02d3be&scoped=true&"
import script from "./MyBrand.vue?vue&type=script&lang=js&"
export * from "./MyBrand.vue?vue&type=script&lang=js&"
import style0 from "./MyBrand.vue?vue&type=style&index=0&id=3f02d3be&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f02d3be",
  null
  
)

export default component.exports